import { useEffect, useState } from 'react';

/** Whether a CSS media query currently matches, kept in step as the window changes.
 *
 * For the cases where a layout decision has to be made in JS rather than in
 * classes — an agent card that can only dock beside the content on a wide
 * screen, say, where its default and its controls depend on the width. */
export function useMediaQuery(query: string): boolean {
    const [matches, setMatches] = useState(
        () => typeof window !== 'undefined' && window.matchMedia(query).matches,
    );

    useEffect(() => {
        const mql = window.matchMedia(query);
        const update = () => setMatches(mql.matches);
        update();
        mql.addEventListener('change', update);
        return () => mql.removeEventListener('change', update);
    }, [query]);

    return matches;
}
